import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { DEFAULT_SIGNING_MUTATION_PARAMS } from "@/modules/patients/detail/conclude/services/useDocumentSigning"
import {
  De_signAttestationGuardianDocumentInput,
  useDeSignLegalGuardianMutation as useDeSignLegalGuardianMutationType,
} from "@/modules/patients/detail/legal-guardian-attestation/de/services/__generated__/useDeSignLegalGuardianMutation.graphql"

const mutation = graphql`
  mutation useDeSignLegalGuardianMutation($input: De_signAttestationGuardianDocumentInput!) {
    de_signAttestationGuardianDocument(input: $input) {
      de_AttestationGuardian {
        id
        createdAt
        createdBy
        signedBy
        signedAt
        updatedAt
        updatedBy
        fileId
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

type Config = Omit<UseMutationConfig<useDeSignLegalGuardianMutationType>, "variables"> & {
  id: De_signAttestationGuardianDocumentInput["id"]
}

const useDeSignLegalGuardianMutation = () => {
  const [commit, isFlight] = useMutationWithErrorDialog<useDeSignLegalGuardianMutationType>(
    mutation,
    DEFAULT_SIGNING_MUTATION_PARAMS,
  )

  const commitHandler = useCallback(
    async (config: Config) => {
      commit({
        variables: {
          input: {
            id: config.id,
          },
        },
        ...config,
      })
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useDeSignLegalGuardianMutation }
